import { Box, Typography } from "@mui/material";
import type { ReactNode } from "react";

interface Props {
  title: string;
  subtitle: string;
  /** A button on the right, e.g. one that adds to the list below. */
  action?: ReactNode;
}

/** The title and one-line purpose at the top of each step of a form. */
export default function StepHeading({ title, subtitle, action }: Props) {
  return (
    <Box
      sx={{
        mb: 2,
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: 2,
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography
          sx={{ fontWeight: 700, fontSize: 16, color: "text.primary" }}
        >
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {subtitle}
        </Typography>
      </Box>
      {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
    </Box>
  );
}
